import { PageId } from 'constants/pages'

export const enum PageIdWoofzVday70 {
  SUBSCRIPTIONS_VDAY_70 = PageId.SUBSCRIPTIONS_VDAY_70,
  CHAT_UPSELL_VDAY_70 = PageId.CHAT_UPSELL_VDAY_70,
  UPSELL_VDAY_70 = PageId.UPSELL_VDAY_70,
  DOWNLOAD_VDAY_70 = PageId.DOWNLOAD_VDAY_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
